import React from 'react';
import { getLabel } from '../data/labels';

function Loader(props) {
    return (
        <div className="xs-loader-container">
            {(props.error ?
                <>
                    <i className="fa fa-exclamation-triangle xs-error-icon"></i>
                    <span className="xs-error-message">{getLabel('general.error_fetching_data')}</span>
                </>
                :
                <div className="xs-loader"></div>
            )}
        </div>
    );
}

export default Loader;